import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import ReactPlayer from 'react-player';
import { Waypoint } from 'react-waypoint';

class VideoBanner extends Component {
  constructor(el) {
    super();
    this.state = { mediaUrl: '', playing: false };
    this.ref = (player) => {
      this.player = player;
    };
  }
  componentDidMount() {
    this.setState({
      mediaUrl: ReactDOM.findDOMNode(this).parentNode.dataset.videoUrl
    });
  }

  render() {
    return (
      <Waypoint
        scrollableAncestor={window}
        onEnter={({ previousPosition, currentPosition }) => {
          this.setState({ playing: true });
        }}
        onLeave={() => {
          this.setState({ playing: false });
        }}
      >
        <div>
          <ReactPlayer
            className="media-player"
            url={this.state.mediaUrl}
            playing={this.state.playing}
            volume={0}
            muted={true}
            loop
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  showinfo: 0
                }
              },
              vimeo: {
                playerOptions: {
                  responsive: true,
                  playsinline: true,
                  controls: false
                }
              }
            }}
          />
        </div>
      </Waypoint>
    );
  }
}

export default component((node, ctx) => {
  const element = <VideoBanner appstate={ctx} parentNode={node} />;
  ReactDOM.render(element, node);
  // return element;

  // Unmount component on Pjax navigation
  return function() {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
